import syncICL from "sync/icl.json";
import syncEVO from "sync/evo.json";

import { SiteInfo, SiteJsonNormalized } from "../settings-types";

export const getSiteInfo = (locale: string): SiteInfo => {
  let site: SiteJsonNormalized = null;

  if (/^.+-evo$/.test(locale)) {
    // evo locale
    site = Object.values(syncEVO.sites).find((item) => {
      return item.locale === locale.replace("-evo", "");
    });
    if (!site) {
      // fallback to de-De
      site = syncEVO.sites["de-DE"];
    }
  } else {
    // icl locale
    // Match on the site key: two sites can share a locale (en-AU and en-AU-sea)
    site = Object.values(syncICL.sites).find((item) => {
      const key = (item as { key?: string }).key ?? item.locale;
      return key === locale.replace("-iframe", "");
    });
    if (!site) {
      // fallback to en-US
      site = syncICL.sites["en-US"];
    }
  }

  return {
    name: site.name ?? "",
    layout: site.layout,
    iso: site.locale,
    code: site.locale,
    dir: site.rtl ? "rtl" : "ltr",
    file: site.locale + "/common.json",
    handle: site.handle,
    iframe: site.hostUrl === site.iframeUrl || /^.+-iframe$/.test(locale),
    branded: site.branded ?? "",
    discoverUrl: site.baseUrl,
    doctorUrl: site.hostUrl,
    quizUrl: site.quizUrl ?? "",
  };
};
